import { createAmountInputCodec } from '../amount/amount-input.js';
// MoonPay Going Live: Gateway disclosure version 1; preserve mandated wording.
export const gatewayDisclosure = {
    beforeLink: 'By proceeding, you agree to two steps under ',
    linkLabel: 'these terms',
    link: 'https://www.moonpay.com/legal/terms',
    afterLink: ': (1) Buying stablecoin from MoonPay and (2) Swapping stablecoin for your chosen destination asset via a decentralised exchange.',
    slippageExplanation: 'Swap will only execute if final price falls within this range.',
};
export function directPurchaseQuantity(purchase, units, locale) {
    return `${createAmountInputCodec(locale, purchase.decimals).format(BigInt(units))} ${purchase.title}`;
}
export function directPurchaseSlippage(review, locale) {
    return review.slippageBps === undefined
        ? null
        : `${createAmountInputCodec(locale, 2).format(BigInt(review.slippageBps))}%`;
}
